import { phone } from '~utils/format';

export default [
  '$scope', 'railsResource', 'User',
  ($scope, $resource, User) => {
    $scope.searchClients = async (name) => {
      const results = await User.query({ search: name }).$promise;
      results.forEach(user => {
        if (user.phone && user.phone.length > 0) {
          user.displayText = `${user.legalName} / ${user.name} / <${user.email}> / tel: ${phone(user.phone)}`;
        } else {
          user.displayText = `${user.legalName} / ${user.name} / <${user.email}>`;
        }
      });
      return results;
    };
  },
];
